import { Card } from 'antd-mobile'
import React from 'react'
import { useNavigate } from 'react-router'
import { useFlashcard } from '../../../../zustand/handlers';

function SingleCategory({ title, name, index }) {
    const flashcard = useFlashcard();
    const navigate = useNavigate();
    return (
        <Card
            style={{
                width: "100%",
                border: `1px solid var(--border-${name})`,
                backgroundColor: `var(--bg-${name})`

            }} onClick={() => {
                navigate("/flashcard")
                flashcard.setCurrent(index)
            }}>
            {title}
        </Card>
    )
}

export default SingleCategory